module.exports = __webpack_public_path__ + "img/ladder-price.5331fb4d.svg";